import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { getAppTitle } from 'venn-ui-kit';

const Watermark = () => {
  const theme = useContext(ThemeContext);

  return <img alt={`Provided by ${getAppTitle()}`} src={theme.Images.vennProvidedLogoGreyscale} width="125" />;
};

export default Watermark;
